import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'carousel-slide',
	templateUrl: './carousel-slide.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class CarouselSlideComponent<T extends string> {
	@Input()
	public slideId: T = `${Math.random()}`.substring(2) as T;

	public containerId?: string;
}
